import { Helmet } from "react-helmet-async";
import {
  ColumnContainer,
  Label,
  Panel,
  SafePanel,
  Space,
  RowContainer,
  LimitedContainerMedium,
  LabelXXL,
  LabelL,
} from "../components/Ui/Ui";
import {
  jobsPageMainData,
} from "../data/JobsPageData";
import { JobsPageMetaData } from "../data/MetaData";
const Karriere = () => {
  return (
    <>
      {/* <Helmet>
        <title>{ContactPageMetaData.title}</title>
        {ContactPageMetaData.meta.map((meta, index) => (
          <meta
            key={index}
            {...(meta.property
              ? { property: meta.property }
              : { name: meta.name })}
            content={meta.content}
          />
        ))}
        <link rel="canonical" href={ContactPageMetaData.canonical} />
        <script type="application/ld+json">
          {JSON.stringify(ContactPageMetaData.structuredData)}
        </script>
      </Helmet> */}
               <Helmet>
              <title>{JobsPageMetaData.title}</title>
              <meta
                name="description"
                content={JobsPageMetaData.content}
              />
            </Helmet>
      <Panel style={{ background: "white" }}>
        <SafePanel normal={false} allowMargin={false}>
          <ColumnContainer>
            <LimitedContainerMedium >
              <LabelXXL
              color= "black" fontWeight="900"
              >
                {jobsPageMainData.title}
              </LabelXXL>
            </LimitedContainerMedium>
            <LimitedContainerMedium>
              <Label style={{ color: "black" }}>
                {jobsPageMainData.description}
              </Label>
            </LimitedContainerMedium>
            <Space style={{height:"2rem"}}/>
            <ColumnContainer style={{gap:"1rem"}}>
            {jobsPageMainData.info.map((point, index) => {
              const Icon = point.icon;
              return (
                <RowContainer key={index} sizing={false}>
                  <ColumnContainer  style={{ justifyContent: "center" }}>
                    <LabelL
                       color= "black"
                       as="a" href={point.link}
                     
                    >
                      {point.description}
                    </LabelL>
    
                  
                  </ColumnContainer>
                </RowContainer>
              );
            })}
            </ColumnContainer>
          </ColumnContainer>
        </SafePanel>
      </Panel>

    </>
  );
};

export default Karriere;
